/*LIBRARY*/
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MenuItem, Select } from "@mui/material";
import centroid from "@turf/centroid";
import { ArrowBackIos } from "@material-ui/icons";
import { featureCollection } from "@turf/helpers";

/*COMPONENT*/
import SolidCheckbox from "../reuseable/SolidCheckbox";
import ICON_VIEW from "../../Assets/jsx/ICON_VIEW";

/*REDUX*/
import {
  set_value_toolbox,
  toolbox_handle_back,
} from "../../App/actions/toolboxActions";

/*PICTURE*/
import icon_trash from "../../Assets/svg/icon_trash.svg";

/*FUNCTION*/
import { create_marker_element } from "../libre_layer/LAYER_TOOLBOX";
// import { get_mode_list } from "./TOOLBOX_TABLE";
import { get_toolbox_mode_list } from "../../App/validation/toolbox_mode_list";

/*HOOKS */
import useLanguage from "../common_hooks/useLanguage";
import Modal from "../common_modal/Modal";
import { array_to_sentence } from "../../App/validation/text_helper";
import {
  generateField,
  select_field_from_default_props,
} from "../../App/validation/generateGeoJson";
import {
  toolbox_save_layer,
  push_features,
} from "../../App/actions/layerNewActions";
import { post_activities } from "../../App/actions/activities";
import { getDetailLayerById } from "../../App/actions/get_features_action";

/*CONST*/

function TOOLBOX_DETAIL_DISTANCE() {
  // hooks
  const dispatch = useDispatch();
  const { dict, language } = useLanguage();

  // global props
  const { map_object } = useSelector((state) => state.layer);
  const toolbox = useSelector((state) => state.toolbox) || {};
  const auth = useSelector((state) => state.auth) || {};
  const { geo_project } = useSelector((state) => state.project) || {};

  const {
    mode_toolbox,
    uuid_name,
    last_saved_feature_uuid,
    modal_cancel_confirmation,
    start_time
  } = toolbox || {};
  const tool = get_toolbox_mode_list(mode_toolbox);
  const unit_options = tool?.unit_options || [];
  const visible_name = mode_toolbox.replace("features", "visible");
  const visible_features = toolbox?.[visible_name];
  const features = toolbox[mode_toolbox];
  const selected_row_toolbox_ids = toolbox[uuid_name];
  const selected_all =
    selected_row_toolbox_ids.length > 0
      ? !features.some(
        (f) => !selected_row_toolbox_ids.includes(f.properties.uuid),
      )
      : false;

  let last_saved_feature_uuid_index;
  if (last_saved_feature_uuid === "") last_saved_feature_uuid_index = Infinity;
  else if (last_saved_feature_uuid === "start") last_saved_feature_uuid_index = -1;
  else {
    // partial save
    last_saved_feature_uuid_index = features.findIndex(
      f => f.properties.uuid === last_saved_feature_uuid
    );
  }


  // local state
  const [unit, set_unit] = useState(unit_options?.[0] || "");
  const [modal_delete, set_modal_delete] = useState(false);
  const [modal_save, set_modal_save] = useState(false);
  const [new_layer_name, set_new_layer_name] = useState("");

  // functions
  const on_clear_select = () => {
    dispatch(
      set_value_toolbox({
        key: uuid_name,
        value: [],
      }),
    );

    const will_be_change_style = features.filter((f) =>
      visible_features.includes(f.properties.uuid),
    );
    if (!map_object) return;

    will_be_change_style.forEach((f) => {
      map_object.setFeatureState(
        { source: "geojson_distance", id: f.properties.uuid },
        { selected: false },
      );
    });
  };

  const on_select_row_uuid = async (uuid) => {
    const selected_row_toolbox_ids = toolbox[uuid_name];
    const willBeSelected = !selected_row_toolbox_ids.includes(uuid);

    // Update Redux
    dispatch(
      set_value_toolbox({
        key: uuid_name,
        value: willBeSelected
          ? [...selected_row_toolbox_ids, uuid]
          : selected_row_toolbox_ids.filter((id) => id !== uuid),
      }),
    );

    // Set feature state sesuai state yang BARU
    map_object.setFeatureState(
      { source: "geojson_distance", id: uuid },
      { selected: willBeSelected }, // ✅ Langsung pake nilai baru
    );
  };

  const fly_to = (uuid) => {
    if (uuid) {
      const feature = toolbox[mode_toolbox].find(
        (item) => item?.properties?.uuid === uuid,
      );
      const geojson = {
        type: "FeatureCollection",
        features: [feature],
      };
      const feature_center = centroid(geojson);
      const longitude = feature_center?.geometry?.coordinates?.[0];
      const latitude = feature_center?.geometry?.coordinates?.[1];
      if (map_object && longitude && latitude) {
        map_object.flyTo({
          center: [longitude, latitude],
          speed: 1,
        });
      }
    }
  };

  const on_hide = (uuid) => {
    const feature_label_name = `${mode_toolbox}_label`;
    const feature_center_name = `${mode_toolbox}_center`;

    const features_label = toolbox?.[feature_label_name];
    const features_center = toolbox?.[feature_center_name];

    let visible_features = [...toolbox?.[visible_name]];
    if (visible_features.includes(uuid)) {
      visible_features = visible_features.filter((item) => item !== uuid);
    } else {
      visible_features.push(uuid);
    }

    if (!map_object) return;

    dispatch(
      set_value_toolbox({
        key: visible_name,
        value: visible_features,
      }),
    );

    map_object.getSource("geojson_distance")?.setData({
      type: "FeatureCollection",
      features: features.filter((item) =>
        visible_features.includes(item.properties.uuid),
      ),
    });
    map_object.getSource("geojson_distance_label")?.setData({
      type: "FeatureCollection",
      features: features_label.filter((item) =>
        visible_features.includes(item.properties.parent_uuid),
      ),
    });

    features_center.forEach((feature) => {
      if (visible_features.includes(feature.properties.uuid)) {
        create_marker_element({
          feature,
          uuid_active: feature.properties.uuid,
          map_object,
        });
      } else {
        const marker_to_remove = document.getElementById(
          `marker_toolbox_${uuid}`,
        );
        if (marker_to_remove) {
          marker_to_remove.remove();
        }
      }
    });
  };

  const on_delete = () => {
    const feature_label_name = `${mode_toolbox}_label`;
    const feature_center_name = `${mode_toolbox}_center`;
    const features_label = toolbox?.[feature_label_name];
    const features_center = toolbox?.[feature_center_name];

    const new_features = features.filter(
      (f) => !selected_row_toolbox_ids.includes(f.properties.uuid),
    );
    const new_visibles = visible_features.filter(
      (uuid) => !selected_row_toolbox_ids.includes(uuid),
    );

    const new_features_label = features_label.filter(
      (item) => !selected_row_toolbox_ids.includes(item.properties.parent_uuid),
    );
    const new_features_center = features_center.filter(
      (item) => !selected_row_toolbox_ids.includes(item.properties.uuid),
    );

    let new_last = features.filter(
      (f, idx) =>
        last_saved_feature_uuid_index > idx &&
        !selected_row_toolbox_ids.includes(f.properties.uuid),
    );
    let new_last_uuid = new_last?.at(-1)?.properties?.uuid;
    if (new_last.length === 0) {
      new_last_uuid = "start";
    }

    // update yang di mapnya
    if (!map_object) return;

    // set features yang terlihat (dishow)
    dispatch(
      set_value_toolbox({
        key: visible_name,
        value: new_visibles,
      }),
    );

    // set features asli
    dispatch(
      set_value_toolbox({
        key: mode_toolbox,
        value: new_features,
      }),
    );
    map_object.getSource("geojson_distance")?.setData({
      type: "FeatureCollection",
      features: new_features,
    });

    // label feature untuk menampilkan titik A ke titik B
    map_object.getSource("geojson_distance_label")?.setData({
      type: "FeatureCollection",
      features: new_features_label,
    });
    dispatch(
      set_value_toolbox({
        key: feature_label_name,
        value: new_features_label,
      }),
    );

    // label tengah untuk menampilkan/menghapus "D-1" dll
    features_center.forEach((feature, idx) => {
      if (selected_row_toolbox_ids.includes(feature.properties.uuid)) {
        const marker_to_remove = document.getElementById(
          `marker_toolbox_${feature.properties.uuid}`,
        );
        if (marker_to_remove) marker_to_remove.remove();
      }
    });
    dispatch(
      set_value_toolbox({
        key: feature_center_name,
        value: new_features_center,
      }),
    );

    // set feature yang diselect
    dispatch(
      set_value_toolbox({
        key: uuid_name,
        value: [],
      }),
    );

    dispatch(
      set_value_toolbox({
        key: "last_saved_feature_uuid",
        value: new_last_uuid,
      }),
    );

    set_modal_delete(false);
  };

  const on_hide_all = () => {
    dispatch(
      set_value_toolbox({
        key: visible_name,
        value: [],
      }),
    );

    // hapus line dari map
    if (map_object?.getSource("geojson_distance")) {
      const geojson_polygon = featureCollection([])
      map_object.getSource("geojson_distance")?.setData(geojson_polygon);
    }

    // hapus label titik awal dan terakhir (A dan B) dari map
    if (map_object?.getSource("geojson_distance_label")) {
      const geojson_polygon = featureCollection([])
      map_object.getSource("geojson_distance_label")?.setData(geojson_polygon);
    }

    // hapus label tengah dari map
    const feature_center_name = `${mode_toolbox}_center`;
    const features_center = toolbox?.[feature_center_name];
    features_center.forEach((feature) => {
      const marker_to_remove = document.getElementById(
        `marker_toolbox_${feature?.properties?.uuid}`,
      );
      if (marker_to_remove) {
        marker_to_remove.remove();
      }
    });
  }

  const on_save = async () => {
    const properties = select_field_from_default_props("LineString");
    const field_names_will_be_saved = [
      {
        name: "id_tool",
        type: "text",
      },
      {
        name: "length_km",
        type: "number",
      },
      {
        name: "length_m",
        type: "number",
      },
    ];

    const fields = properties.concat(
      field_names_will_be_saved.map((i) => generateField(i.name, i.type, false)),
    );

    const body = {
      name: new_layer_name || "New Layer",
      description: "",
      type: "LineString",
      folder: "",
      user_id: auth?.user?._id,
      geo_project_id: geo_project._id,
      fields: fields,
      properties,
      status: "digitasi",
      architecture: "v2",
      label_config: {
        is_use_label_text: true,
        is_use_label_image: false,
        label_text_field_key_array: [
          "length_km"
        ],
        label_image_field_key_array: [],
        style_mode: "style_1",
        background_color_primary: "rgba(11, 217, 130, 1)",
        outline_color_primary: "rgba(0,0,0,0)",
        text_color_primary: "rgba(255, 255, 255, 1)",
        is_use_pin: false,
        text_stroke_width: 0,
        text_stroke_color: "rgba(255,255,255,1)",
        font_size: 11,
        font_weight: "bold",
        pin_height: 0
      },
    };

    let geo_layer = await dispatch(toolbox_save_layer(body));

    const features_will_save = features
      .filter((f) => selected_row_toolbox_ids.includes(f.properties.uuid))
      .map((f) => {
        let new_properties = {};
        fields.forEach((i) => {
          new_properties[i.key] = isNaN(f.properties[i.name])
            ? f.properties[i.name]
            : Number(f.properties[i.name]);
        });
        return {
          ...f,
          properties: new_properties,
        };
      });

    await dispatch(
      push_features({
        geo_layer_id: geo_layer?._id,
        features: features_will_save,
      }),
    );

    const toolbox_type = mode_toolbox.replace("features_", "").replace("scoring_", "");
    if (start_time) await dispatch(post_activities({ action: `toolbox-${toolbox_type}-save`, duration_ms: new Date() - start_time }));

    set_modal_save(false);
    set_new_layer_name("");

    on_clear_select();
    on_hide_all();

    const body_get = {
      geo_layer_id: geo_layer?._id,
      geo_project_id: geo_project._id,
      flyStatus: true,
      geo_layer_item: geo_layer,
    };
    dispatch(getDetailLayerById(body_get));
  };

  const on_select_all = () => {
    if (!selected_all) {
      const will_be_selected = features.map((f) => f.properties.uuid);
      dispatch(
        set_value_toolbox({
          key: uuid_name,
          value: will_be_selected,
        }),
      );

      const will_be_change_style = features.filter((f) =>
        visible_features.includes(f.properties.uuid),
      );
      if (!map_object) return;

      will_be_change_style.forEach((f) => {
        map_object.setFeatureState(
          { source: "geojson_distance", id: f.properties.uuid },
          { selected: true },
        );
      });
    } else {
      on_clear_select();
    }
  };

  const on_back = (value) => {
    let new_value = !modal_cancel_confirmation?.is_open;
    if (value === false || value === true) {
      new_value = value;
    }

    if (
      last_saved_feature_uuid_index < features.length
    ) {
      dispatch(
        set_value_toolbox({
          key: "modal_cancel_confirmation",
          value: {
            is_open: new_value,
            is_back_active: true,
            tab_value: "",
          },
        }),
      );
    } else {
      dispatch(toolbox_handle_back());
    }
  };

  const deleted_list = features.reduce(function (result, feature) {
    if (selected_row_toolbox_ids.includes(feature.properties.uuid)) {
      return result.concat(feature.properties.id_tool);
    }
    return result;
  }, []);

  // content
  const modal_delete_content = modal_delete && (
    <Modal
      isOpen={modal_delete}
      onClose={() => set_modal_delete(false)}
      modalSize="small"
      title={dict["Confirmation"][language]}
      is_hide="hide"
    >
      <div style={{ marginBottom: "8px", maxHeight: "400px", overflowY: "auto" }}>
        <p style={{ display: "inline" }}>{dict["Are you sure to delete"][language]}{` `}</p>
        <p style={{ display: "inline", fontWeight: 700, fontSize: "18px" }}>
          {deleted_list && array_to_sentence(deleted_list)}
        </p>
        <p style={{ display: "inline" }}>{`?`}</p>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "end",
          gap: "15px",
        }}
      >
        <button
          onClick={() => set_modal_delete(false)}
          className="button_pill button_white"
        >
          {dict["Cancel"][language]}
        </button>
        <button
          onClick={() => on_delete()}
          className="button_pill flex"
          style={{
            backgroundColor: "#BD0000",
            color: "white",
          }}
        >
          <img src={icon_trash} alt="Delete" />
          {dict["Delete"][language]}
        </button>
      </div>
    </Modal>
  );

  const modal_save_content = modal_save && (
    <Modal
      isOpen={modal_save}
      onClose={() => set_modal_save(false)}
      modalSize="small"
      title={dict["Give a name"][language]}
      is_hide="hide"
    >
      <div style={{ marginBottom: "8px" }}>
        <p style={{ display: "inline", fontWeight: 600, fontSize: "14px" }}>
          {dict["Layer Name"][language]}
        </p>
      </div>

      <div style={{ marginBottom: "25px" }}>
        <input
          type="text"
          style={{ borderRadius: "20px", padding: "0 15px 0 15px" }}
          value={new_layer_name}
          onChange={(e) => set_new_layer_name(e.target.value)}
        />
      </div>

      <div style={{ display: "flex", justifyContent: "end", gap: "10px" }}>
        <button
          onClick={() => set_modal_save(false)}
          className="button_pill flex"
          style={{
            border: "1px solid black",
            color: "black",
          }}
        >
          {dict["Cancel"][language]}
        </button>
        <button
          onClick={() => on_save()}
          className="button_pill flex"
          style={{
            backgroundColor: "black",
            color: "white",
          }}
        >
          {dict["Save"][language]}
        </button>
      </div>
    </Modal>
  );

  return (
    <>
      <section
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "25px",
          margin: "30px 27px 25px 27px",
        }}
      >
        <button
          onClick={() => on_back(true)}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            fontWeight: 700,
            width: "fit-content",
            padding: "2px 10px",
            borderRadius: "2px",
          }}
        >
          <ArrowBackIos style={{ fontSize: "12px" }} />
          {dict["Back to Menu"][language]}
        </button>

        <div>
          <span style={{ fontSize: "18px", fontWeight: "700" }}>{dict["Results"][language]}</span>
          <p style={{ fontSize: "14px", marginTop: "10px" }}>
            {dict["Straight-line distance calculated between two points."][language]}
          </p>
        </div>
      </section>

      <hr style={{ height: "5px", backgroundColor: "#BABABA", opacity: 0.1 }} />

      <section
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "20px",
          margin: "20px 0px 15px 0px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "10px",
            margin: "0px 27px 0px 27px",
          }}
        >
          <label
            style={{ fontWeight: 700, fontSize: "0.875rem", color: "#B2B2B2" }}
          >
            {dict["Table"][language]}
          </label>
          <Select
            style={{
              height: "28px",
              marginLeft: "10px",
              borderRadius: "20px",
              fontSize: "12px",
              fontWeight: "600",
            }}
            value={unit}
            onChange={(e) => set_unit(e.target.value)}
          >
            {unit_options.map((unit, idx) => {
              return (
                <MenuItem key={idx} value={unit}>
                  {unit}
                </MenuItem>
              );
            })}
          </Select>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "start",
            alignItems: "center",
            gap: "10px",
            margin: "0 27px 0px 27px",
          }}
        >
          <SolidCheckbox
            id="select_all"
            checked={selected_all}
            onChange={() => on_select_all()}
            style={{ width: "18px", height: "18px", cursor: "pointer" }}
          />
          <label
            htmlFor="select_all"
            style={{ fontSize: "14px", cursor: "pointer" }}
          >
            {dict["Select All"][language]}
          </label>
        </div>

        {features.length > 0 && mode_toolbox !== "grouping" && (
          <div>
            <table className="toolbox_table">
              <thead>
                <tr>
                  <th>{dict["Select"][language]}</th>
                  <th>No.</th>
                  <th>{"ID Tool"}</th>
                  <th>{dict["Distance"][language]}</th>
                </tr>
              </thead>
              <tbody>
                {features.map((item, idx) => {
                  const viewStatus = visible_features.includes(item.properties.uuid);

                  return (
                    <React.Fragment key={idx}>
                      <tr
                        style={{ backgroundColor: last_saved_feature_uuid_index < idx ? "lightGrey" : "white" }}
                        onClick={() => fly_to(item.properties.uuid)}>
                        <td style={{ display: "flex", alignItems: "center", gap: "20px", justifyContent: "center" }}>
                          <SolidCheckbox
                            checked={selected_row_toolbox_ids.includes(
                              item.properties.uuid,
                            )}
                            onChange={() =>
                              on_select_row_uuid(item.properties.uuid)
                            }
                            style={{ width: "18px", height: "18px" }}
                          />
                          <button
                            style={{
                              color: "black",
                            }}
                            onClick={() => on_hide(item.properties.uuid)}
                          >
                            <ICON_VIEW
                              color={viewStatus ? "#000" : "#b7b7b7"}
                              strokeWidth={viewStatus ? 4 : 3}
                              style={{ width: "18px", height: "18px" }}
                            />
                          </button>
                        </td>
                        <td>{idx + 1}</td>
                        <td>{item?.properties?.id_tool}</td>
                        <td>
                          {unit === "meter"
                            ? Intl.NumberFormat("id-ID").format(
                              item?.properties?.length_m,
                            )
                            : Intl.NumberFormat("id-ID").format(
                              item?.properties?.length_km,
                            )}
                        </td>
                      </tr>
                    </React.Fragment>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
        {selected_row_toolbox_ids?.length > 0 && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "5px",
            }}
          >
            <button
              onClick={() => on_clear_select()}
              className="button_pill button_white"
            >
              {dict["Cancel"][language]}
            </button>
            <button
              onClick={() => set_modal_delete(true)}
              className="button_pill flex"
              style={{
                backgroundColor: "#BD0000",
                color: "white",
              }}
            >
              <img src={icon_trash} alt="Delete" />
              {dict["Delete"][language]}
            </button>
            <button
              onClick={() => set_modal_save(true)}
              title={`${dict["Save"][language]}${language === "eng" ? " the" : ""} ${dict["Lines"][language]}`}
              className="button_pill flex"
              style={{
                backgroundColor: "black",
                color: "white",
              }}
            >
              {dict["Save"][language]}
            </button>
          </div>
        )}
      </section>
      {modal_delete_content}
      {modal_save_content}
    </>
  );
}

export default TOOLBOX_DETAIL_DISTANCE;